import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { BreakdownItem } from "../models/reportItem.model";

// Placeholder - adjust this interface to match your actual API response
export interface DonorMetricData { // Renamed to avoid conflict if DonorMetric exists elsewhere
  metricKey: string;
  metricValue: any;
}

export interface DonorWithMetrics {
  donorId: string; // Or whatever your primary ID for a donor is
  [key: string]: any; // Allows for arbitrary metric keys as properties
  // If metrics are in a nested structure, adjust accordingly:
  // donorName?: string; 
  // metrics?: DonorMetricData[]; 
  // metrics?: { [key: string]: any };
}

@Injectable({
  providedIn: "root",
})
export class ReportingService {
  private baseUrl = environment.reportingApiUrl;
  private reportingUrl = `${this.baseUrl}/reporting/questions`; // Adjust if needed

  constructor(private http: HttpClient) {}

  getQuestionnaireBreakdown(
    questionText: string,
    filters?: any
  ): Observable<BreakdownItem[]> {
    let params = new HttpParams().set("questionText", questionText);

    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (filters[key]) {
          params = params.set(key, filters[key]);
        }
      });
    }

    return this.http.get<BreakdownItem[]>(
      `${this.reportingUrl}/questionnaire-breakdown`,
      { params }
    );
  }

  getEligibilityBreakdown(filters?: any): Observable<BreakdownItem[]> {
    let params = new HttpParams();

    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (filters[key]) {
          params = params.set(key, filters[key]);
        }
      });
    }

    return this.http.get<BreakdownItem[]>(
      `${this.reportingUrl}/eligibility-breakdown`,
      { params }
    );
  }

  getMetricsBreakdown(filters?: any): Observable<Record<string, BreakdownItem[]>> {
    let params = new HttpParams();
    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (filters[key]) {
          params = params.set(key, filters[key]);
        }
      });
    }
    return this.http.get<Record<string, BreakdownItem[]>>(
      `${this.reportingUrl}/grouped-metrics-breakdown`,
      { params }
    ).pipe(
      map(response => {
        // TODO: !! change the keys in the backend!!!
        if (response['recipientname']) {
          response['recipients'] = response['recipientname'];
          delete response['recipientname'];
        }
        if (response['relationshiptorecipient']) {
          response['relationship'] = response['relationshiptorecipient'];
          delete response['relationshiptorecipient'];
        }
        return response;
      })
    );
  }

  getDonorsWithMetrics(filters?: any): Observable<DonorWithMetrics[]> {
    // The 'filters' object from the component typically contains dateFrom, dateTo, status, etc.
    // The backend expects a POST request with a body.
    // We'll pass the 'filters' object directly as the body.
    // Adjust this if the backend expects a specific structure for the 'string of filters'.
    const body = {
      dateFrom: filters?.dateFrom,
      dateTo: filters?.dateTo,
      ...filters // This will spread all properties from the filters object into the body.
    };

    return this.http.post<DonorWithMetrics[]>(`${this.reportingUrl}/donors-with-metrics`, body);
  }



}

  
